// extracted by mini-css-extract-plugin
export default {"root":"FormattedDateLabel_root__AQ6al"};